import { useState } from "react";
import ListItem from "../TaskCreatorAndEditorSheet/ListItem/ListItem";
import ErrorAddOn from "../TaskCreatorAndEditorSheet/ListItem/ErrorAddOn/ErrorAddOn";
import { useTranslation } from "@coworker/locales";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { ItemNoAndTypeWithOrderedDetails } from "@coworker/apprestructured/src/task-management/types/TaskDetailTypes";
import { ConfirmSheetModal } from "@coworker/apprestructured/src/shared/components/ConfirmSheetModal/ConfirmSheetModal";
import { ArticlesQuantityContent } from "./ArticlesQuantityContent/ArticlesQuantityContent";
import { isLoading, Loading } from "../../loading";
import { LOADING } from "../../loading";
import { useItemsWithPieces } from "../../services/useItemsWithPieces";

interface ArticlesQuantityProps {
  disabled?: boolean;
  isError?: boolean;
  itemsNoAndTypeOrderedDetails:
    | ItemNoAndTypeWithOrderedDetails[]
    | null
    | Loading;
  items: Item[];
  handlePiecesChange: (itemNo: string, newPieces: number) => void;
  handleConfirm: () => void;
}
export const ArticlesQuantity = ({
  disabled,
  isError,
  itemsNoAndTypeOrderedDetails,
  items,
  handlePiecesChange,
  handleConfirm,
}: ArticlesQuantityProps) => {
  const [showModal, setShowModal] = useState(false);
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const { t } = useTranslation();

  const handleConfirmWithClose = () => {
    handleConfirm();
    handleCloseModal();
  };

  const itemWithPieces = useItemsWithPieces(
    items,
    itemsNoAndTypeOrderedDetails ?? LOADING
  );
  if (isLoading(itemWithPieces) || isLoading(itemsNoAndTypeOrderedDetails)) {
    return <div>Loading...</div>;
  }
  const totalPieces = Array.isArray(itemsNoAndTypeOrderedDetails)
    ? itemsNoAndTypeOrderedDetails.reduce(
        (acc, item) => acc + item.pieces_ordered.quantity,
        0
      )
    : 0;
  const description = t("countTotalPiecesString", { count: totalPieces });

  return (
    <>
      <ListItem
        testId="get-new-article-list-item"
        title={t("getNewArticleString")}
        onClick={handleOpenModal}
        emphasised={true}
        description={description}
        disabled={disabled}
        addOn={
          isError ? (
            <ErrorAddOn testId="add-location-error">
              {t("pleaseFillInString")}
            </ErrorAddOn>
          ) : null
        }
      />
      <ConfirmSheetModal
        title={t("getNewArticlesString")}
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        handleConfirm={handleConfirmWithClose}
        content={
          <div>
            <ArticlesQuantityContent
              itemsWithPieces={itemWithPieces}
              itemsNoAndTypeOrderedDetails={itemsNoAndTypeOrderedDetails}
              handlePiecesChange={handlePiecesChange}
            />
          </div>
        }
      />
    </>
  );
};
